import React, { Component } from 'react';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// require('datatables.net-responsive');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: '#',
    data: 'IS_ACTIVE',
    render: function (data, type, row) {
      if (type === 'display') {
        if (data === true)
          return `<div class="custom-control custom-switch"><input id="customSwitch-${row.id}" type="checkbox" class="custom-control-input" checked/><label class="custom-control-label" for="customSwitch-${row.id}"></label></div>`;
        else
          return `<div class="custom-control custom-switch"><input id="customSwitch-${row.id}" type="checkbox" class="custom-control-input"/><label class="custom-control-label" for="customSwitch-${row.id}"></label></div>`;
      }
      return data;
    }
  },
  {
    title: 'Copy',
    data: 'id',
    render: function (data, type, row) {
      if (type === 'display') {
        return `
        <button class="btn btn-outline-secondary btn-sm copy-btn" 
          data-id="${row.TRAINING_ID}" 
          data-report-id="${row.report_id}">
          <i class="fas fa-copy"></i>
        </button>`;
      }
      return data;
    }
  },
  {
    title: 'ID',
    data: 'TRAINING_ID'
  },
  {
    title: 'ชื่อหลักสูตร',
    data: 'TRAINING_NAME'
  },
  {
    title: 'วิทยากร',
    data: 'TRAINING_INSTRUCTOR'
  },
  {
    title: 'สถานที่',
    data: 'TRAINING_VENUE'
  },
  {
    title: 'ตำแหน่งผู้เรียน',
    data: 'TRAINING_GROUP_NAME'
  },
  {
    title: 'วันที่-เวลาอบรม',
    data: 'TRAINING_DATE_TRAINING'
  },
  {
    title: 'วันที่หมดอายุ(ถ้ามี)',
    data: 'TRAINING_EXPIRED_DT'
  },
  {
    title: 'ผู้บันทึกข้อมูล',
    data: 'BY'
  },
  {
    title: 'View',
    data: 'id',
    render: function (data, type, row) {
      if (type === 'display') {
        return `<a class="btn btn-outline-secondary btn-sm" id="${row.TRAINING_ID}_view"><i class="fas fa-search" /></a>`;
      }
      return data;
    }
  },
  {
    title: 'PDF [aA]',
    data: 'id',
    render: function (data, type, row) {
      if (type === 'display') {
        return `<a class="btn btn-outline-warning btn-sm" id="${row.TRAINING_ID}_printAll"><i class="fas fa-print"></i></a><a class="btn btn-outline-success btn-sm" id="${row.TRAINING_ID}_printSigned"><i class="fas fa-print"></i><i class="fas fa-signature"></i></a>`;
      }
      return data;
    }
  },
  // {
  //   title: 'PDF [aA] [SIGNED]',
  //   data: 'id',
  //   render: function (data, type, row) {
  //     if (type === 'display') {
  //       return `<a class="btn btn-outline-secondary btn-sm" id="${row.TRAINING_ID}_printSigned"><i class="fas fa-print" /><i class="fas fa-signature" /></a>`;
  //     }
  //     return data;
  //   }
  // },
  {
    title: 'PDF [NPS]',
    data: 'id',
    render: function (data, type, row) {
      if (type === 'display') {
        // return `<a class="btn btn-outline-secondary btn-sm" id="${row.TRAINING_ID}_printNpsAll"><i class="fas fa-print" /></a>`;
        return `<a class="btn btn-outline-warning btn-sm" id="${row.TRAINING_ID}_printNpsAll"><i class="fas fa-print"></i></a><a class="btn btn-outline-success btn-sm" id="${row.TRAINING_ID}_printNpsSigned"><i class="fas fa-print"></i><i class="fas fa-signature"></i></a>`;
      }
      return data;
    }
  },
  {
    title: 'PDF [RE/LO]',
    data: 'id',
    render: function (data, type, row) {
      if (type === 'display') {
        // return `<a class="btn btn-outline-secondary btn-sm" id="${row.TRAINING_ID}_printNpsAll"><i class="fas fa-print" /></a>`;
        return `<a class="btn btn-outline-warning btn-sm" id="${row.TRAINING_ID}_printReloAll"><i class="fas fa-print"></i></a><a class="btn btn-outline-success btn-sm" id="${row.TRAINING_ID}_printReloSigned"><i class="fas fa-print"></i><i class="fas fa-signature"></i></a>`;
      }
      return data;
    }
  }
  // {
  //   title: 'PDF [NPS] [SIGNED]',
  //   data: 'id',
  //   render: function (data, type, row) {
  //     if (type === 'display') {
  //       return `<a class="btn btn-outline-secondary btn-sm" id="${row.TRAINING_ID}_printNpsSigned"><i class="fas fa-print" /></a>`;
  //     }
  //     return data;
  //   }
  // }
];

function reloadTableData(names, page) {
  const table = $(`#${id}`).DataTable();

  table.clear();
  table.rows.add(names);
  table.draw();
  table.page(page).draw('page');
  setTimeout(function () {
    table.columns.adjust();
  }, 50);
}

class TableCourse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: { USERNAME: 'HI' },
      onUpdate: () => { }
    };
  }

  componentDidMount() {
    var table = $(`#${id}`).DataTable({
      data: this.props.names,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[1, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      errMode: 'none',
      scrollX: true
      // responsive: true,
      // columnDefs: [
      //   {target: 0, responsivePriority: 1},
      //   {target: 1, responsivePriority: 1},
      //   {target: 2, responsivePriority: 2},
      //   {target: 3, responsivePriority: 2},
      //   {target: 4, responsivePriority: 2},
      //   {target: 5, visible: false},
      //   {targets: -1, responsivePriority: 1}
      // ]
    });

    table.on('page', (event) => {
      var info = table.page.info();
      this.props.onPageChange(info.page);
    });

    $.fn.dataTable.ext.errMode = 'none';
    // table.columns.adjust();

    $(`#${id} tbody`).on('click', 'a', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      const idAttr = $this.attr('id') || '';
      const actions = idAttr.split('_')[1];
      if (!actions) return;
      if (actions === 'view') {
        this.props.onToggle(data, true);
      } else if (actions === 'printAll') {
        this.props.onPrintToggle(data, 'ALL');
      } else if (actions === 'printSigned') {
        this.props.onPrintToggle(data, 'SIGNED');
      } else if (actions === 'printNpsAll') {
        this.props.onPrintToggle(data, 'NPSALL');
      } else if (actions === 'printNpsSigned') {
        this.props.onPrintToggle(data, 'NPSSIGNED');
      } else if (actions === 'printReloAll') {
        this.props.onPrintToggle(data, 'RELOALL');
      } else if (actions === 'printReloSigned') {
        this.props.onPrintToggle(data, 'RELOSIGNED');
      }
    });

    $(`#${id} tbody`).on('click', '.copy-btn', (event) => {
      const $btn = $(event.currentTarget);
      const tr = $btn.closest('tr');
      const data = table.row(tr).data(); 

      const trainingId = $btn.data('id');
      const reportId = $btn.data('report-id');

      if (this.props.navigate) {
        this.props.navigate(`/hrd-make/copy/${trainingId}/${reportId}`);
      } else {
        window.location.href = `/hrd-make/copy/${trainingId}/${reportId}`;
      }
    });

    $(`#${id} tbody`).on('change', 'input', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      this.setState({
        item: {
          ...data,
          UPDATE_ON: 'MAIN',
          IS_ACTIVE: $this.prop('checked') === true ? '1' : '0'
        }
      });
      this.state.onUpdate({
        ...data,
        UPDATE_ON: 'MAIN',
        IS_ACTIVE: $this.prop('checked') === true ? '1' : '0'
      });
    });

    this.setState({
      onUpdate: (item) => {
        this.props.onUpdate(item);
      }
    });
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    reloadTableData(nextProps.names, nextProps.page);
    return true;
  }

  render() {
    return (
      <div>
        <table
          ref="main"
          className="display nowrap example"
          id={id}
          style={{ width: '100%' }}
        />
      </div>
    );
  }
}
export default TableCourse;
